import script from "./JoinView.vue?vue&type=script&lang=ts&setup=true"
export * from "./JoinView.vue?vue&type=script&lang=ts&setup=true"

import "./JoinView.vue?vue&type=style&index=0&id=6b2c6d75&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/webapp/webapp/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6b2c6d75"]])

export default __exports__